import { render, staticRenderFns } from "./activity-workshop-photo.vue?vue&type=template&id=712d1650&scoped=true&"
import script from "./activity-workshop-photo.vue?vue&type=script&lang=js&"
export * from "./activity-workshop-photo.vue?vue&type=script&lang=js&"
import style0 from "./activity-workshop-photo.vue?vue&type=style&index=0&id=712d1650&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712d1650",
  null
  
)

export default component.exports